import {Component, Inject, DOCUMENT, ChangeDetectionStrategy} from '@angular/core';


@Component({
    selector: 'app-update-app',
    templateUrl: './update-app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UpdateAppComponent {
  constructor(@Inject(DOCUMENT) public document: Document) {
  }
}
